/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DealcloudSettings} from '../models/DealcloudSettings';
import type {Error} from '../models/Error';

export interface GetDealCloudCrmSettings$Request {
    accountId: number;
}

export interface GetDealCloudCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDealCloudCrmSettingsRequest = createAction<PayloadData<void, GetDealCloudCrmSettings$Request>>('DEALCLOUD_CONTROLLER__GET_DEAL_CLOUD_CRM_SETTINGS__REQUEST');
export const getDealCloudCrmSettingsSuccess = createAction<PayloadData<DealcloudSettings, GetDealCloudCrmSettings$Request>>('DEALCLOUD_CONTROLLER__GET_DEAL_CLOUD_CRM_SETTINGS__SUCCESS');
export const getDealCloudCrmSettingsFailure = createAction<PayloadData<Error, GetDealCloudCrmSettings$Request, true>>('DEALCLOUD_CONTROLLER__GET_DEAL_CLOUD_CRM_SETTINGS__FAILURE');

export const getDealCloudCrmSettingsActions = [
    getDealCloudCrmSettingsRequest,
    getDealCloudCrmSettingsSuccess,
    getDealCloudCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDealCloudCrmSettings = (meta: GetDealCloudCrmSettings$Request, config?: GetDealCloudCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getDealCloudCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/dealcloud/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveDealCloudCrmSettings$Request {
    accountId: number;
    dealcloudSettings: DealcloudSettings;
}

export interface SaveDealCloudCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveDealCloudCrmSettingsRequest = createAction<PayloadData<void, SaveDealCloudCrmSettings$Request>>('DEALCLOUD_CONTROLLER__SAVE_DEAL_CLOUD_CRM_SETTINGS__REQUEST');
export const saveDealCloudCrmSettingsSuccess = createAction<PayloadData<void, SaveDealCloudCrmSettings$Request>>('DEALCLOUD_CONTROLLER__SAVE_DEAL_CLOUD_CRM_SETTINGS__SUCCESS');
export const saveDealCloudCrmSettingsFailure = createAction<PayloadData<Error, SaveDealCloudCrmSettings$Request, true>>('DEALCLOUD_CONTROLLER__SAVE_DEAL_CLOUD_CRM_SETTINGS__FAILURE');

export const saveDealCloudCrmSettingsActions = [
    saveDealCloudCrmSettingsRequest,
    saveDealCloudCrmSettingsSuccess,
    saveDealCloudCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {DealcloudSettings} meta.dealcloudSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveDealCloudCrmSettings = (meta: SaveDealCloudCrmSettings$Request, config?: SaveDealCloudCrmSettings$Config) => {
    return {
        CALL_API: {
            types: saveDealCloudCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/dealcloud/settings`,
            TRANSPORT_REQUEST_BODY: meta.dealcloudSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

